<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="applyDialogVisible"
        center
        class="detail-dialog-container"
        width="1056px">
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">个人会员</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <div class="dialog-content flex flex-wrap">
                <div v-for="(item,index) in members" :key="index" class="personal flex flex-direction align-center">
                    <el-image :src="item.headImg" class="image flex-shrink" fit="scale-down"></el-image>
                    <div class="name">{{ item.name }}</div>
                    <el-tooltip class="item" effect="light" :content="item.company" placement="bottom">
                        <div class="company ovHide padding-lr-xs">{{ item.company }}</div>
                    </el-tooltip>
                </div>
            </div>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                class="self-end"
                layout="prev, pager, next, jumper"
                @current-change="init">
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>

import {getMemberList} from "../../api/data";

export default {
    name: "MorePersonalDialog",
    props: {
        applyDialogVisible: {
            type: Boolean,
            default: false
        },
        oid: { //详情ID
            type: Number,
        }
    },
    data() {
        return {
            members:[],
            page: 1,
            limit:10,
            total:0
        }
    },
    created() {
        if (this.oid)this.init()
    },
    methods: {
        async init() {
            let _data = await getMemberList(this.oid,2,this.page,this.limit)
            this.members = _data.data
            this.total = _data.total_number
        },
        cancel() {
            this.$emit('watchState', false)
        },

    },
    watch: {
        oid() {
            if (this.oid)this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.detail-dialog-container {
    .dialog-container {
        .dialog-header {
            height: 55px;

            .dialog-title {
                font-size: 18px;
                font-weight: bold;
                color: #0a2240;
                text-align: center;
            }

            .dialog-close {
                font-size: 21px;
                color: #0a2240;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .dialog-content {
            height: 505px;
            padding: 0 20px;

            .personal {
                width: 176px;
                height: 194px;
                background-color: #182c5b;
                border-radius: 6px;
                margin-top: 15px;

                &:not(:nth-child(5n+1)) {
                    margin-left: 19px;
                }

                .image {
                    width: 100%;
                    height: 140px;
                    border-radius: 6px 6px 0 0;
                    background-color: #ffffff11;
                }

                .name {
                    font-size: 16px;
                    font-weight: bold;
                    color: #ffffff;
                    margin-top: 6px;
                }


                .company {
                    font-size: 12px;
                    color: #ffffff;
                    margin-top: 6px;
                    text-align: center;
                    width: 100%;
                }
            }
        }
    }
}
</style>